<template>
  <div style="height: 100%;width: 100%;overflow: hidden;">
    <StandardSearchPageView
      ref="table"
      rowKey="id"
      :col="3"
      :columns="getColumns()"
      :queryParams="queryParams"
      :searchOptions="searchOptions"
      :operationBoxStyle="{ padding: '0 0 16px' }"
      :requestPromise="loadDataList"
    >
      <a-button slot="operation" type="primary" icon="plus" @click="onAddEvent">新建</a-button>
      <template v-slot:status="{ text, record }">
        <span>{{ text }}</span>
      </template>
      <template v-slot:action="{ record }">
        <a-space>
          <a @click="onSwitchStatus(record)">{{ record.status == 1 ? '下架' : '上架' }}</a>
          <a @click="onEditEvent(record)">编辑</a>
        </a-space>
      </template>
    </StandardSearchPageView>
    <SimpleFormEditorDialog
      v-if="showDialog"
      ref="editDialog"
      :editConfigList="editConfigList"
      :item="selectItem"
      :rules="rules"
      :title="selectItem && selectItem.id ? '编辑关联报价' : '新建关联报价'"
      @cancel="showDialog = false"
      @ok="onEditResultEvent"
    >
      <template v-slot:productId="{ form }">
        <a-input
          v-model="form.productId"
          placeholder="请输入"
          @blur="onProductIdBlur(form)"
        />
      </template>
      <template v-slot:systemRoomId="{ form }">
        <a-select
          v-model="form.systemRoomId"
          :options="roomOptions"
          placeholder="请选择"
          style="width: 100%"
          allowClear
          @change="onSystemRoomChange(form)"
        />
      </template>
      <template v-slot:ratePlanId="{ form }">
        <a-select
          v-model="form.ratePlanId"
          :options="ratePlanOptions"
          placeholder="请选择"
          style="width: 100%"
          allowClear
        />
      </template>
      <template v-slot:autoPushMode="{ form }">
        <a-radio-group v-model="form.autoPushMode">
          <a-radio :value="2">每次更新价格库存</a-radio>
          <a-radio :value="1">每次仅更新库存，不更新价格</a-radio>
        </a-radio-group>
      </template>
      <template v-slot:autoPushFutureDays="{ form }">
        <a-input-number
          v-model="form.autoPushFutureDays"
          :min="1"
          :max="90"
          :precision="0"
          placeholder="请输入"
          style="width: 100%"
        />
      </template>
      <template v-slot:autoPushIntervalMinutes="{ form }">
        <a-input-number
          v-model="form.autoPushIntervalMinutes"
          :min="30"
          :max="1440"
          :precision="0"
          placeholder="请输入"
          style="width: 100%"
        />
      </template>
      <template v-slot:tip>
        <div style="color: #999;line-height: 22px;">
          *代理通侧创建售卖房型需为卖价模式，目前不支持底价模式
        </div>
      </template>
    </SimpleFormEditorDialog>
  </div>
</template>

<script>
import SimpleFormEditorDialog from '@/customComponents/SimpleFormEditorDialog.vue'
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'

export default {
  name: 'AssociatedQuoteComponent',
  components: {
    SimpleFormEditorDialog,
    StandardSearchPageView
  },
  data () {
    return {
      showDialog: false,
      selectItem: undefined,
      queryParams: {},
      accountOptions: [],
      roomOptions: [],
      ratePlanOptions: [],
      lastProductId: undefined,
      searchOptions: [
        {
          name: '商品ID',
          key: 'productId',
          type: 'input',
          placeholder: '请输入'
        },
        {
          name: '酒店名称',
          key: 'hotelName',
          type: 'input',
          placeholder: '请输入'
        },
        {
          name: '状态',
          key: 'status',
          type: 'select',
          placeholder: '请选择',
          selectOptions: [
            { label: '正常', value: 1 },
            { label: '下架', value: 0 }
          ]
        },
        {
          name: '更新日期',
          key: 'updateStartDate,updateEndDate',
          type: 'rangePicker'
        }
      ],
      rules: {
        pushXcHotelId: [{ required: true, message: '请输入代理通酒店ID', trigger: 'change,blur' }],
        pushXcSaleRoomId: [{ required: true, message: '请输入代理通售卖房型ID', trigger: 'change,blur' }],
        pushXcAccountId: [{ required: true, message: '请选择关联供应商', trigger: 'change,blur' }],
        productId: [{ required: true, message: '请输入关联酒店商品ID', trigger: 'change,blur' }],
        systemRoomId: [{ required: true, message: '请选择关联房型', trigger: 'change,blur' }],
        ratePlanId: [{ required: true, message: '请选择推送报价', trigger: 'change,blur' }],
        autoPushMode: [{ required: true, message: '请选择推送方式', trigger: 'change' }],
        autoPushFutureDays: [
          { required: true, message: '请输入关联报价推送天数', trigger: 'change' },
          { type: 'number', min: 1, max: 90, message: '关联报价推送天数可设置 1~90', trigger: 'change' }
        ],
        autoPushIntervalMinutes: [
          { required: true, message: '请输入定时任务更新时间', trigger: 'change' },
          { type: 'number', min: 30, max: 1440, message: '定时任务更新时间可设置 30~1440 分钟', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    editConfigList () {
      return [
        {
          name: '代理通酒店ID',
          key: 'pushXcHotelId',
          placeholder: '请输入'
        },
        {
          name: '代理通售卖房型ID',
          key: 'pushXcSaleRoomId',
          placeholder: '请输入'
        },
        {
          name: '关联供应商',
          key: 'pushXcAccountId',
          type: 'select',
          placeholder: '请选择',
          selectOptions: this.accountOptions
        },
        {
          name: '关联石基酒店商品ID',
          key: 'productId',
          placeholder: '请输入',
          slot: true
        },
        {
          name: '选择关联石基房型',
          key: 'systemRoomId',
          placeholder: '请选择',
          slot: true
        },
        {
          name: '选择推送报价',
          key: 'ratePlanId',
          placeholder: '请选择',
          slot: true
        },
        {
          name: ' ',
          key: 'autoPushMode',
          slot: true
        },
        {
          name: '关联报价推送天数',
          key: 'autoPushFutureDays',
          placeholder: '请输入',
          slot: true
        },
        {
          name: '定时任务更新时间',
          key: 'autoPushIntervalMinutes',
          placeholder: '请输入',
          slot: true
        },
        {
          name: ' ',
          key: 'tip',
          slot: true
        }
      ]
    }
  },
  methods: {
    getMerchantId () {
      return this.$store.getters.userInfo.merchantId
    },
    mapOptionList (list) {
      return (list || []).map(item => ({
        label: item.name,
        value: item.id
      }))
    },
    getRequestParams (params) {
      const requestParams = {
        ...params,
        ...params.limitDto,
        limitDto: undefined
      }
      return requestParams
    },
    loadDataList (params) {
      const requestParams = {
        ...this.getRequestParams(params),
        merchantId: this.getMerchantId()
      }
      return this.getHttpServices().getSourceService().post('pushXC/quote-mappings/page', requestParams)
    },
    formatDisplayUpdateTime (record) {
      if (!record || !record.nextPushTime) return '---'
      const minutes = Number(record.autoPushIntervalMinutes)
      if (Number.isNaN(minutes)) return record.nextPushTime
      const dateHelper = this.getDateHelper()
      const nextPushMoment = dateHelper.getMomentFromDateStr(record.nextPushTime)
      if (!nextPushMoment || !nextPushMoment.isValid()) return '---'
      return dateHelper.formatDate(
        nextPushMoment.clone().subtract(minutes, 'minutes'),
        'YYYY-MM-DD HH:mm:ss'
      )
    },
    getColumns () {
      return [
        {
          title: '商品ID',
          dataIndex: 'productId',
          width: '100px'
        },
        {
          title: '代理通酒店ID',
          dataIndex: 'pushXcHotelId',
          width: '140px'
        },
        {
          title: '酒店名称',
          dataIndex: 'hotelName',
          width: '200px'
        },
        {
          title: '代理通售卖房型ID',
          dataIndex: 'pushXcSaleRoomId',
          width: '160px'
        },
        {
          title: '系统房型ID|名称',
          dataIndex: 'systemRoomDisplayName',
          width: '180px'
        },
        {
          title: '关联供应商账号',
          dataIndex: 'pushXcAccountName',
          width: '160px'
        },
        {
          title: '状态',
          dataIndex: 'statusName',
          width: '100px',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '180px',
          customRender: (text, record) => this.formatDisplayUpdateTime(record)
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '140px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
    refreshData (reset) {
      this.$refs.table && this.$refs.table.refresh(reset)
    },
    loadAccountOptions () {
      return this.getHttpServices().getSourceService()
        .post('pushXC/quote-mappings/options/accounts', {
          merchantId: this.getMerchantId()
        })
        .then(list => {
          this.accountOptions = this.mapOptionList(list)
        })
        .catch(err => {
          this.accountOptions = []
          console.error(err)
        })
    },
    loadRoomOptions (productId) {
      return this.getHttpServices().getSourceService()
        .post('pushXC/quote-mappings/options/rooms', {
          merchantId: this.getMerchantId(),
          productId: Number(productId)
        })
        .then(list => {
          this.roomOptions = this.mapOptionList(list)
        })
        .catch(err => {
          this.roomOptions = []
          console.error(err)
        })
    },
    loadRatePlanOptions (productId, systemRoomId) {
      return this.getHttpServices().getSourceService()
        .post('pushXC/quote-mappings/options/rate-plans', {
          merchantId: this.getMerchantId(),
          productId: Number(productId),
          systemRoomId: Number(systemRoomId)
        })
        .then(list => {
          this.ratePlanOptions = this.mapOptionList(list)
        })
        .catch(err => {
          this.ratePlanOptions = []
          console.error(err)
        })
    },
    onProductIdBlur (form) {
      if (String(form.productId || '') === String(this.lastProductId || '')) {
        return
      }
      this.lastProductId = form.productId
      form.systemRoomId = undefined
      form.ratePlanId = undefined
      this.roomOptions = []
      this.ratePlanOptions = []
      if (!form.productId) {
        return
      }
      this.loadRoomOptions(form.productId)
    },
    onSystemRoomChange (form) {
      form.ratePlanId = undefined
      this.ratePlanOptions = []
      if (!form.productId || !form.systemRoomId) {
        return
      }
      this.loadRatePlanOptions(form.productId, form.systemRoomId)
    },
    async onAddEvent () {
      this.roomOptions = []
      this.ratePlanOptions = []
      this.lastProductId = undefined
      await this.loadAccountOptions()
      this.selectItem = {
        pushXcHotelId: undefined,
        pushXcSaleRoomId: undefined,
        pushXcAccountId: undefined,
        productId: undefined,
        systemRoomId: undefined,
        ratePlanId: undefined,
        autoPushMode: 2,
        autoPushFutureDays: undefined,
        autoPushIntervalMinutes: undefined
      }
      this.showDialog = true
    },
    async onEditEvent (item) {
      this.roomOptions = []
      this.ratePlanOptions = []
      this.lastProductId = item.productId
      await this.loadAccountOptions()
      if (item.productId) {
        await this.loadRoomOptions(item.productId)
      }
      if (item.productId && item.systemRoomId) {
        await this.loadRatePlanOptions(item.productId, item.systemRoomId)
      }
      this.selectItem = {
        id: item.id,
        pushXcHotelId: item.pushXcHotelId,
        pushXcSaleRoomId: item.pushXcSaleRoomId,
        pushXcAccountId: item.pushXcAccountId,
        productId: item.productId,
        systemRoomId: item.systemRoomId,
        ratePlanId: item.ratePlanId,
        autoPushMode: item.autoPushMode != null ? item.autoPushMode : 2,
        autoPushFutureDays: item.autoPushFutureDays,
        autoPushIntervalMinutes: item.autoPushIntervalMinutes,
        status: item.status
      }
      this.showDialog = true
    },
    onSwitchStatus (item) {
      const params = {
        id: item.id,
        merchantId: this.getMerchantId(),
        status: String(item.status) === '1' ? 0 : 1
      }
      this.getHttpServices().getSourceService().post('pushXC/quote-mappings/status', params)
        .then(() => {
          this.$message.success('操作成功！')
          this.refreshData(false)
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '操作失败，请重试！')
          console.error(err)
        })
    },
    onEditResultEvent (params) {
      const isEdit = !!params.id
      const url = isEdit ? 'pushXC/quote-mappings/update' : 'pushXC/quote-mappings/create'
      const requestParams = {
        productId: Number(params.productId),
        merchantId: this.getMerchantId(),
        pushXcHotelId: Number(params.pushXcHotelId),
        pushXcSaleRoomId: Number(params.pushXcSaleRoomId),
        systemRoomId: Number(params.systemRoomId),
        pushXcAccountId: Number(params.pushXcAccountId),
        ratePlanId: Number(params.ratePlanId),
        autoPushMode: Number(params.autoPushMode),
        autoPushFutureDays: Number(params.autoPushFutureDays),
        autoPushIntervalMinutes: Number(params.autoPushIntervalMinutes),
        status: isEdit ? params.status : 1
      }
      if (isEdit) {
        requestParams.id = params.id
      }
      this.getHttpServices().getSourceService().post(url, requestParams)
        .then(() => {
          this.showDialog = false
          this.selectItem = undefined
          this.$message.success('操作成功！')
          this.refreshData(!isEdit)
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '操作失败，请重试！')
          console.error(err)
        })
    }
  }
}
</script>

<style scoped></style>
